import React, { useEffect, useRef, useState } from "react";
import axios from "axios"; 
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";


const Awards = () => {
  const [Certificates, setAwards] = useState([]);

  useEffect(() => {
    axios
      .get("https://www.isolsgroup.com/new/api/ApiAwards", {
        headers: {
          "X-API-KEY": "ISOLS", // 🔐 Replace with your actual key if required
        },
        params: { // sends ?category_id=5
          homepage: 1
        }
      })
      .then((response) => {
        if (response.data && Array.isArray(response.data.data)) {
          // ✅ Limit to only first 4 records
          const homepageawards = response.data.data
            .filter((item) => item.homepage === "1" || item.homepage === 1)
            .slice(0, 4);
          setAwards(homepageawards);
        } else {
          console.warn("Unexpected API response:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching brand data:", error);
      });
  }, []);


  return (
    <section className="awards-recognitions ">
        <div className="container mx-auto px-4">
            <div className="row b-member-info">
                <div className="col-xs-12 col-sm-3">
                    <div className="b-mod-heading">
                        <p className="first-heading font-secondary member-prof">Awards &</p>
                        <h4 className="heading-line line-right customColor customPseudoElBg member-name" >
                        <strong>Recognitions</strong>
                        </h4>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-9">
                    <div className="b-member-caption">
                        <h6 className="contact-info-title customPseudoElBg font-secondary">BEST TECHNOLOGY & DIGITAL COMPANY OF THE YEAR AWARD</h6>
                        <p>ISOLS Group has been awarded as the Best Technology and Digital Company 2021 Award by Topgallant Media.</p>
                    </div>
                </div>
            </div>
            <div className="row">
                {Certificates.length > 0 ? (
                Certificates.map((award, index) => (
                <div className="col-xs-6 col-sm-3 text-center" key={index}>
                    <div className="member-img">
                    <img src={`https://www.isolsgroup.com/new/uploaded-images/awards/${award.image}`} 
                    className="img-responsive" loading="lazy" alt="awards" width="262px" height="260px" />
                    </div>
                </div>
                ))
                ) : (
                <p className="text-center mt-4">No Isolion Data available.</p>
                )}
                <div className="col-md-12">
                    <div className="aboutt">
                        <Link to="/award-certifications" className="btn btn-default-arrow btn-sm">
                        <FaArrowRight />
                            Explore More
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
);
};

export default Awards;